import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonTypeEnum } from './button-type.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass]
})
export class ButtonComponent {
  @Input() type: ButtonTypeEnum = ButtonTypeEnum.primary;
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Output() buttonClick = new EventEmitter<void>(true);
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
